/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerFindAllQueryResponse, AiUserFeedbackControllerFindAllQueryParams, AiUserFeedbackControllerFindAll401, AiUserFeedbackControllerFindAll403 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerFindAll";

function getAiUserFeedbackControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/ai-user-feedback` as const }  
  return res
}

/**
 * @summary List AI user feedback for the current principal
 * {@link /api/v1/ai-user-feedback}
 */
export async function aiUserFeedbackControllerFindAll(params?: AiUserFeedbackControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiUserFeedbackControllerFindAllQueryResponse, ResponseErrorConfig<AiUserFeedbackControllerFindAll401 | AiUserFeedbackControllerFindAll403>, unknown>({ method : "GET", url : getAiUserFeedbackControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}